import { ISchedule } from '../../Interfaces/Schedule.interfaces';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import React from 'react';
import ScheduleSettings from './ScheduleSettings/';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import _ from 'lodash';
import config from '../../globals/config'
const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        marginBottom: theme.spacing(3),
    },
}));

export default function Schedule(props: ISchedule) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    function handleChange(event: any, newValue: any) {
        setValue(newValue);
    }

    return (
        <React.Fragment>
            <Paper className={classes.root}>
                <Tabs centered indicatorColor="primary" onChange={handleChange} textColor="primary" value={value}>
                    <Tab label="Sessions" />
                    <Tab label="Settings" />
                </Tabs>
            </Paper>
            {value === 0 && (
                <Typography component="h2" variant="h4">
                    {' '}
                    Please visit the{' '}
                    <a
                        href={`${config.REACT_APP_HOST_PRIMARY}`}
                        rel="noopener noreferrer"
                        style={{ color: '#3C4252' }}
                        target="_blank"
                    >
                        Event Farm Dashboard
                    </a>{' '}
                    to view the itinerary
                </Typography>
            )}
            {value === 1 && <ScheduleSettings {...props} />}
        </React.Fragment>
    );
}
